// extracted by mini-css-extract-plugin
export default {"Box":"use-issue-type-editor-module__Box--LMZjW","Box_1":"use-issue-type-editor-module__Box_1--Aa2Fw","ColorDecorator":"use-issue-type-editor-module__ColorDecorator--jOAds"};